import { Directive, HostBinding, Input } from '@angular/core';

export type TMFAppearance = 'no-padding' | 'no-fill';

@Directive({
  selector: 'mat-form-field[xAppearance]',
})
export class MatFieldAppearanceDirective {
  @HostBinding('class')
  @Input()
  xAppearance: TMFAppearance | TMFAppearance[];

  constructor() {}
}
